const musicLinkUrlPartsHR = {
    "view": {
        "table": {
            "title": "Popis dijelova URL-a vaših glazbenih poveznica",
            "column": {
                "part": "Dio",
                "owner": "Vlasnik",
                "action": "Akcija"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "button": {
                "exportCSV": "Izvezi CSV"
            }
        },
        "message": {
            "success": "Dio URL-a glazbene poveznice je uklonjen!",
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!",
            "noUrlparts": "Trenutno je ova značajka dostupna samo nekolicini odabranih korisnika, ali dobra vijest je da ćete je uskoro moći koristiti. Pratite ovaj prostor!"
        },
        "modal": {
            "delete": {
                "header": "Izbrisati {{mlUrlpart}}?",
                "body": "Jeste li sigurni da želite izbrisati ovaj dio URL-a glazbene poveznice?"
            },
            "canNotDelete": {
                "header": "Ne može se izbrisati dio URL-a glazbene poveznice {{mlUrlPart}}",
                "body": "Dio URL-a glazbene poveznice {{mlUrlPart}} ne može se izbrisati jer je već povezan s glazbenom poveznicom."
            }
        }
    },
    "add": {
        "form": {
            "label": {
                "subUser": "Podkorisnik",
                "part": "Dio",
                "owner": "Vlasnik",
                "addUrlPart": "Dodaj dio URL-a",
                "editUrlPart": "Uredi dio URL-a"
            },
            "placeholder": {
                "subUser": "Odaberite podkorisnika..."
            },
            "help_text": {
                "subUser": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati glazbenu poveznicu za bilo kojeg od svojih podkorisnika, inače ostavite neodabrano."
            },
            "button": {
                "reset": "Poništi",
                "submit": "Pošalji"
            },
            "validation": {
                "part": {
                    "required": "Dio je obavezan",
                    "max": "Mora imati točno 16 znakova"
                }
            },
            "message": {
                "subUserLimit": "Ovaj podkorisnik je iskoristio maksimalni limit od 10 dijelova URL-a.",
                "urlPartAlreadyTaken": "Ovaj URL glazbene poveznice je već zauzet od strane vašeg računa ili računa drugog korisnika. Molimo pokušajte nešto drugo."
            }
        },
        "message": {
            "addSuccess": "Dio URL-a glazbene poveznice je dodan!",
            "updateSuccess": "Dio URL-a glazbene poveznice je ažuriran!",
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!"
        }
    }
};

export default musicLinkUrlPartsHR;